module.exports = "https://cdn-challenge.mathletics.com/app/111/assets/images/7dbdf90e9c54dbd26994a13322506493.svg";